/**
 * ページングコンポーネント(画像、商品検索に使う想定)
 */
export default {
    template: '#paging_component_template',
    props: {
        // 総ページ数
        pages: {
            type: Number,
            default: 0,
            required: true
        },
        // 現在のページ番号
        current_page: {
            type: Number,
            default: 1,
            required: true
        },
        // ページネーションに表示するページ数の上限
        limit_page_count: {
            type: Number,
            default: 5,
            required: false
        },
    },
    computed: {
        // ページ中央
        half() {
            return Math.ceil(this.limit_page_count / 2);
        },
        // 最初へボタン
        firstBtn() {
            return (this.current_page != 1);
        },
        // 前へボタン
        prevBtn() {
            return (this.current_page != 1);
        },
        // 左ドット
        leftDot() {
            return (this.current_page - 1 > 1);
        },
        // 右ドット
        rightDot() {
            return (this.current_page + this.half <= this.pages);
        },
        // 次へボタン
        nextBtn() {
            return (this.current_page != this.pages);
        },
        // 最後へボタン
        lastBtn() {
            return (this.current_page != this.pages);
        },
        /**
         * ページネーションで表示するページ番号の範囲を取得する
         * @return {Array<number>} ページ番号の配列
         */
        displayPageRange() {
            let start, end;
            if (this.pages < this.limit_page_count) {
                // ページネーションのrangeよりページ数がすくない場合
                start = 1;
                end = this.pages;
            } else if (this.current_page < this.half) {
                // 現在のページ番号が中央より小さい場合、左端を1とする
                // 右端はrange - 1 とする
                start = 1;
                end = start + this.limit_page_count - 1;
            } else if (this.pages - this.half < this.current_page) {
                // 現在のページが中央より大きい場合、右端をページ数とする
                // 左端はページ数 - range + 1とする
                end = this.pages;
                start = end - this.limit_page_count + 1;
            } else {
                // activeページを中央にする
                start = this.current_page - this.half + 1;
                end = this.current_page + this.half - 1;
            }

            let indexes = [];
            for (let i = start; i <= end; i++) {
                indexes.push(i);
            }
            return indexes;
        },
    },
    emits: ['get-data'],
    methods: {

        // ページ先頭に移動する
        first() {
            this.emitGetData(1);
        },
        // 1ページ前に移動する
        prev() {
            this.emitGetData(this.current_page - 1);
        },
        /**
         * 指定したページに移動する
         * @param {number} index ページ番号
         */
        pageSelect(index) {
            if (this.current_page === index) {
                // current_pageをクリックされた場合は何もせず返す
                return;
            }
            this.emitGetData(index);
        },
        // 1ページ次に移動する
        next() {
            this.emitGetData(this.current_page + 1);
        },
        // ページ後尾に移動する
        last() {
            this.emitGetData(this.pages);
        },

        // -------------------------
        // emit
        // -------------------------

        /**
         * 指定ページのデータを取得する
         */
        emitGetData: function (page) {
            this.$emit('get-data', page);
        },
    }
};
